import moment from 'moment'
export default {
    getFormattedDate(date, format) {
        if (!date || !format) return
        return moment(date).format(format)
    },
    getDiffDate(date1, date2, unit, isAbs) {
        if (!date1 || !date2 || !unit) {
            return
        }
        let diff = moment(date1).diff(moment(date2), unit)
        if (isAbs) {
            return Math.abs(diff)
        }
        return diff
    }
}